import React, { useContext } from 'react';

import { SiteContext } from '@context';
import { useLocations, useEnvironment } from '@hooks';

import { GoogleMapContainer } from './styles';

interface IStaticMapProps extends React.HTMLAttributes<HTMLDivElement> {
  forceProduction?: boolean;
}

const GoogleMap = ({
  className,
  forceProduction = false,
  ...rest
}: IStaticMapProps) => {
  const env = useEnvironment();
  const locations = useLocations();
  const { state } = useContext(SiteContext);

  const src =
    !forceProduction && env === 'development'
      ? 'about:blank'
      : locations.find((l) => l.name === state.location)?.googleMapsEmbedUri;

  const style: React.CSSProperties =
    !forceProduction && env === 'development'
      ? {
          border: '6000px solid black',
        }
      : {
          border: 0,
        };

  if (!src) {
    return null;
  }

  console.log(src);

  return (
    <GoogleMapContainer
      className={['static_map', className].join(' ')}
      {...rest}
    >
      <iframe
        src={src}
        width="100%"
        height="350"
        style={style}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </GoogleMapContainer>
  );
};

export { GoogleMap };
